module.exports = __webpack_public_path__ + "static/Sergei-over-98be03cb194b3a73571093ce612e1363.png";